import {useCallback, useState} from 'react';
import {commitTicketingMutation} from '../../../graphql/forecastRelay';
import AcceptTicketAiSuggestedActionMutation from '../../../../../mutations/ticketing/tickets/acceptTicketAiSuggestedActionMutation';
import {useCreateForecastTask} from './useCreateForecastTask';

interface AcceptArgs {
	ticketId: string;
	actionId: string;
	title: string;
	/**
	 * Forecast project the new task is created under. Required: every task must
	 * belong to a project, and CreateTask rejects a request without one. The
	 * caller must have a project chosen before invoking accept.
	 */
	projectId: string;
	assignedPersonIds: string[];
	dueDate: string | null;
	description: string | null;
}

interface Options {
	onCompleted?: () => void;
	onError?: (error: Error) => void;
}

export function useAcceptSuggestedAction(options?: Options) {
	const [inFlight, setInFlight] = useState(false);
	const {submit: createTask} = useCreateForecastTask();

	const accept = useCallback(
		(args: AcceptArgs) => {
			setInFlight(true);
			const fail = (error: unknown) => {
				setInFlight(false);
				options?.onError?.(error instanceof Error ? error : new Error(String(error)));
			};
			// Step 1: create the real Forecast task via the shared CreateTask service.
			createTask({
				name: args.title,
				projectId: args.projectId,
				assignedPersonIds: args.assignedPersonIds,
				dueDate: args.dueDate,
				description: args.description,
			})
				.then(task => {
					// Step 2: link + resolve + log timeline event atomically on the backend.
					commitTicketingMutation(
						AcceptTicketAiSuggestedActionMutation,
						{
							ticketId: args.ticketId,
							actionId: args.actionId,
							forecastTaskId: task.id,
							taskCompanyId: task.companyTaskId,
						},
						() => {
							setInFlight(false);
							options?.onCompleted?.();
						},
						fail
					);
				})
				.catch(fail);
		},
		[options, createTask]
	);

	return {accept, inFlight};
}
